import React from 'react';

const HeaderTitle = () => (
    <div className="title">
        <h1>East Grange House</h1>
    </div>
    );

export default HeaderTitle;